import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ConstantService} from '../../constant/constant.service';
import 'rxjs/add/operator/map';
import * as mime from "mime-types";
import {HttpResponse} from "@angular/common/http/src/response";
import {BehaviorSubject, Observable} from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class LoanService {

    private changeLoanCount = new BehaviorSubject({});
    currentCount = this.changeLoanCount.asObservable();
  
    private changeCount = new BehaviorSubject(0);
    currentOrg = this.changeCount.asObservable();

    constructor(
        public constantService: ConstantService,
        public http: HttpClient
    ) {
    }

    get(param: Array<object>) {
        if (!param.length) return this.http.get(this.constantService.getUrl(this.constantService.LOANS));
        else return this.http.get(this.constantService.getUrlByQuery(this.constantService.LOANS, param));
    }

    getLoans(params?: any) {
        return this.http.get(this.constantService.getUrl(this.constantService.LOANS), {
            params: params,
            observe: 'response'
        }).map((resp: any) => {
            let count = resp.headers.get('X-Total-Count');
            return {count: parseInt(count), data: resp.body.data};
        });
    }

    loanDetail(id) {
        return this.http.get(this.constantService.getUrl(`${this.constantService.LOANAPPLICANT}/${id}`));
    }

    pingLoanDetails(id) {
        return this.http.get(this.constantService.getUrl(`${this.constantService.LOANAPPLICANT}/${id}`), {
            headers: {'X-Prevent-Loader': 'false'}
        });
    }

    lead(body){
        return this.http.post(this.constantService.getUrl(`${this.constantService.APPLICATION}/lead`), body);
    }

    loanInit(body){
        return this.http.post(this.constantService.getUrl(`${this.constantService.APPLICATION}/init`), body);
    }

    loanUpdate(body,loanId){
        return this.http.put(this.constantService.getUrl(`${this.constantService.APPLICATION}/${loanId}/loan`), body);
    }

    paymentSchedule(param) {
        return this.http.get(this.constantService.getUrl(`${this.constantService.APPLICATION}/schedules`),{
            params : param
        });
    }

    sendCustomerId(body){
        return this.http.post(this.constantService.getUrl(`${this.constantService.APPLICATION}/sendCustomerId`), body);
    }


    basicInfo(body,id){
        return this.http.put(this.constantService.getUrl(`${this.constantService.APPLICATION}/${id}/basic`), body);
    }

    sendOtp(body) {
        return this.http.post(this.constantService.getUrl(`${this.constantService.APPLICATION}/otp/send`), body);
    }

    address(body,id) {
        return this.http.put(this.constantService.getUrl(`${this.constantService.APPLICATION}/${id}/address`), body);
    }

    employmentDetails(body, id) {
        return this.http.put(this.constantService.getUrl(`${this.constantService.APPLICATION}/${id}/employer`), body);
    }

    kyc(body, id) {
        let formData  = new FormData();
        formData.append('aadhar', body.aadhar);
        formData.append('password', body.password);
        formData.append('offlineKYC', body.offlineKYC);

        return this.http.put(this.constantService.getUrl(`${this.constantService.APPLICATION}/${id}/kyc`), formData);
    }

    kycOnline(body, id) {
        return this.http.put(this.constantService.getUrl(`${this.constantService.APPLICATION}/${id}/kyc`), body);
    }

    sendBitly(id){
        return this.http.post(this.constantService.getUrl(`${this.constantService.APPLICATION}/${id}/sendCustomerLink`), null);
    }

    sendAABitly(id){
        return this.http.post(this.constantService.getUrl(`${this.constantService.APPLICATION}/${id}/sendAALink`), null);
    }

    applyForEligibleAmount(id){
        return this.http.post(this.constantService.getUrl(`${this.constantService.APPLICATION}/${id}/applyForEligibleAmount`), null);
    }

    tenureList(){
        return this.http.get(this.constantService.getUrl(`${this.constantService.SETTINGS}/subvention`));
    }

    getTenureList(loanAmount){
        return this.http.get(this.constantService.getUrlByQuery(`${this.constantService.BRANCHES}/me/tenures`, [{
            name: 'amount',
            value: loanAmount
        }]));
    }

    loanStatus(params?: any) {
        return this.http.get(this.constantService.getUrl(this.constantService.LOANS), {
            params: params,
            observe: 'response'
        }).map((resp: any) => {
            let count = resp.headers.get('X-Total-Count');
            return {count: parseInt(count), data: resp.body.data};
        });
    }

    applicationStatus(params?: any) {
        return this.http.get(this.constantService.getUrl(this.constantService.LOANAPPLICANT), {
            params: params,
            observe: 'response'
        }).map((resp: any) => {
            let count = resp.headers.get('X-Total-Count');
            return {count: parseInt(count), data: resp.body.data};
        });
    }

    getPathToInvoice(id){
        return this.http.get(this.constantService.getUrl( this.constantService.APPLICATION + `/${id}/invoice/signed`))
    }

    getAddressProofPathS3(id){
        return this.http.get(this.constantService.getUrl( this.constantService.APPLICATION + `/${id}/addressProof/signed`))
    }

    getPathToCoverNoteS3(id){
        return this.http.get(this.constantService.getUrl( this.constantService.APPLICATION + `/${id}/insurance/cover/signed`))
    }

    getIdProofPathS3(id){
        return this.http.get(this.constantService.getUrl( this.constantService.APPLICATION + `/${id}/idProof/signed`))
    }

    uploadInvoice(id, file) {
        let formData = new FormData();
        formData.append('invoice', file, `file.${mime.extension(file.type)}`);
        return this.http.put(this.constantService.getUrl(this.constantService.LOANS + `/${id}/upload/invoice`), formData);
    }


    // Additional Document Upload
    uploadAdditionalDocuments(id, body) {
        return this.http.post(this.constantService.getUrl(this.constantService.LOANS + `/${id}/upload/additionalDocs`), body);
      }

    uploadIncomeDocuments(id, body) {
        return this.http.post(this.constantService.getUrl(`${this.constantService.APPLICATION}/${id}/upload/incomeDocs`), body);
    }

    uploadAddressProof(id, data) {
        let formData = new FormData();
        formData.append('addressProof', data.file, `file.${mime.extension(data.file.type)}`);
        formData.append('type', data.type);
        return this.http.put(this.constantService.getUrl(this.constantService.LOANS + `/${id}/upload/addressProof`), formData);
    }

    getLoanDetails(id){
        return this.http.get(this.constantService.getUrl( this.constantService.LOANS + `/${id}`));
    }

    customerInfo(customerData, id){
        return this.http.get(this.constantService.getUrlByQuery( this.constantService.APPLICATION + `/${id}/customerInfo`,[{
            name: 'customerId',
            value: customerData.customerId
        }]));
    }

    cancelApplication(id, body){
        return this.http.put(this.constantService.getUrl(`${this.constantService.APPLICATION}/${id}/cancel`), body);
    }

    profile(){
        return this.http.get(this.constantService.getUrl(`${this.constantService.USERS}/me`));
    }

    downloadExcelApplication(params?: any): Observable<HttpResponse<Blob>> {
        return this.http.get(this.constantService.getUrl(this.constantService.LOANAPPLICANT + '/download/excel'), {
            params: params,
            observe: 'response',
            responseType: 'blob'
        })
    }

    downloadExcelLoan(params?: any): Observable<HttpResponse<Blob>> {
        return this.http.get(this.constantService.getUrl(this.constantService.LOANS + '/download/excel'), {
            params: params,
            observe: 'response',
            responseType: 'blob'
        })
    }

    loans(id) {
        return this.http.get(this.constantService.getUrl(`${this.constantService.LOANS}/${id}`));
    }

    verifyPan(body) {
        return this.http.post(this.constantService.getUrl(`${this.constantService.APPLICATION}/verify/pan`), body);
    }

    verifyOtp(body) {
        return this.http.post(this.constantService.getUrl(`${this.constantService.APPLICATION}/otp/verify`), body);
    }

    getApplicationCount() {
        return this.http.post(this.constantService.getUrl(this.constantService.LOANAPPLICANT + '/counts'), {});
    }

    getDisbursementList(id, body = {}) {
    return this.http.post(this.constantService.getUrl(`${this.constantService.BRANCHES}/${id}/disbursmentbanklist`),body);
    }

    getBranch(params) {
        return this.http.get(this.constantService.getUrl(this.constantService.APPLICATION + '/branchList'), {params});
      }

    getLoanCount(body: Object) {
        return this.http.post(this.constantService.getUrl(this.constantService.LOANS + `/bucket/totalcount`), body);
      }    
    
}